import EmbeddableCheckbox from "@components/C138_EmbeddableForm/EmbeddableCheckbox";
import styles from "@components/Form/FormFields/FormFields.module.scss";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { FieldValues, FormState } from "react-hook-form";

export interface ProgrammesDataItemType {
  id: string;
  name: string;
  value: string;
}

export interface ProgrammeList {
  [key: string]: ProgrammesDataItemType[];
}

export interface ProgrammesListProps {
  register: any;
  programme: string;
  programmesHeadingText?: string;
  programmesHintText: string;
  programmesSelectedTypes: Array<string>;
  setProgrammesSelectedTypes: (value: string[]) => void;
  programmesListData?: ProgrammeList;
  formState: FormState<FieldValues>;
  name: string;
}

const ProgrammesListSection = (props: ProgrammesListProps) => {
  const {
    register,
    formState,
    programme,
    programmesListData,
    programmesHeadingText,
    programmesHintText,
    programmesSelectedTypes,
    setProgrammesSelectedTypes,
    name,
  } = props;

  const [showHint, setShowHint] = useState(true);
  useEffect(() => {
    setProgrammesSelectedTypes(programmesSelectedTypes);
  }, []);

  const errorId = `${name}-error`;
  const hasError = !!formState.errors?.[name];

  const handleProgramChange = (event: Event & { target: HTMLInputElement }) => {
    const { value, checked } = event.target;

    if (checked) {
      setProgrammesSelectedTypes([...programmesSelectedTypes, value]);
    } else {
      setProgrammesSelectedTypes(
        programmesSelectedTypes.filter(
          (chosenProgram) => chosenProgram !== value
        )
      );
    }
  };

  useEffect(() => {
    programmesSelectedTypes.length > 0 ? setShowHint(false) : setShowHint(true);
  }, [programmesSelectedTypes]);

  const getValidationError = (value) => {
    if (value?.length === 0) {
      return programmesHintText !== ""
        ? programmesHintText
        : "Programmes of interest is required";
    } else return null;
  };
  return (
    <fieldset>
      <legend>
        <h4>
          {programmesHeadingText}
        </h4>
      </legend>

      <div className={"form-row"}>
        {programmesListData &&
          programme &&
          programmesListData[programme]?.map((programmeItem) => {
            return (
              <div key={programmeItem.id} className="form-field base6">
                <EmbeddableCheckbox
                  label={programmeItem.name}
                  id={programmeItem.value}
                  value={programmeItem.value}
                  checked={programmesSelectedTypes.includes(
                    programmeItem.value
                  )}
                  aria-invalid={hasError ? "true" : undefined}
                  aria-describedby={hasError ? errorId : undefined}
                  {...register(name, {
                    required: true,
                    validate: getValidationError,
                    onChange: handleProgramChange,
                  })}
                />
              </div>
            );
          })}

        {showHint && programmesHintText !== "" && (
          <div className={styles["form-field"]}>
            <div className="field">
              <input
                id="hiddenPOIChecked"
                name="hiddenPOIChecked"
                type="hidden"
                value=""
              />
            </div>

            <div className={styles["message-wrapper"]}>
              <p className={styles.message}>{programmesHintText}</p>
            </div>
          </div>
        )}

        {formState.errors && formState.errors[name] && (
          <div className={clsx(styles["form-row"], styles.error)}>
            <div className={styles["form-field"]}>
              <div
                className={clsx(
                  "field",
                  "message-wrapper",
                  "inline-message",
                  styles["message-wrapper"],
                  formState.errors[name]?.message && "field_error_msg"
                )}
              >
                <p
                  id={errorId}
                  className={clsx(
                    "message",
                    styles.message,
                    formState.errors[name].type === "required" && "active",
                    formState.errors[name].type === "required" && styles.active
                  )}
                >
                  {/* {formState.errors[name]?.message} */}
                  {formState.errors[name] &&
                    formState.errors[name].type === "required" && (
                      <span>{programmesHintText}</span>
                    )}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </fieldset>
  );
};
export default ProgrammesListSection;
